import * as fromApi from "../../../core/models/loginResponse";
import { Agency } from "../../../core/models/agency";

export const createAgencies = (response: fromApi.LoginResponse): Agency[] => {
  return response?.agencies?.map((agency) => {
    const result: Agency = {
      address: agency.a1,
      city: agency.c,
      email: agency.e,
      id: agency.id,
      name: agency.n,
      phone1: agency.p1,
      phone2: agency.p2,
      phone3: agency.p3,
      state: agency.s,
      url: agency.u,
      zip: agency.z,
    };
    return result;
  });
};
